// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { ActiveStatus } from './active-status';
import { ManufacturerProductTypeConfigAddon } from './manufacturer-product-type-config-addon';
import { PoDetail } from './po-detail';
import { ProductType } from './product-type';
import { ActiveStatusEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ManufacturerProductTypeConfig extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key */
  id!: number;
  /** Enum FK activeStatus */
  activeStatusId!: ActiveStatusEnum;
  /** String */
  configDescription!: string;
  /** String(512) */
  configName!: string;
  /** Boolean */
  isForStockOrdersOnly!: boolean;
  /** Int32 FK productType */
  productTypeId!: number;
  /** FK activeStatusId */
  activeStatus!: ActiveStatus;
  /** Inv FK manufacturerProductTypeConfigId */
  manufacturerProductTypeConfigAddons!: ManufacturerProductTypeConfigAddon[];
  /** Inv FK manufacturerProductTypeConfigId */
  poDetails!: PoDetail[];
  /** FK productTypeId */
  productType!: ProductType;
}

